export { default as SettingsIcon } from '~icons/lucide/settings';
